export class LEDGER_ITEM_TYPE  {
    static readonly Credit: string = '00000078-1000-0000-0000-000000000001';
    static readonly Debit: string = '00000078-1000-0000-0000-000000000002';
    static readonly InitialCreditWriteOff: string = '00000078-1000-0000-0000-000000000003';
    static readonly CreditPayment: string = '00000078-1000-0000-0000-000000000004';
    static readonly Refund: string = '00000078-1000-0000-0000-000000000005';
    static readonly DebitAdjustment: string = '00000078-1000-0000-0000-000000000006';
    static readonly CreditAdjustment: string = '00000078-1000-0000-0000-000000000007';
    static readonly CreditAdjustmentInsurance: string = '00000078-1000-0000-0000-000000000008';
    static readonly ClaimCreated: string = '00000078-1000-0000-0000-000000000009';
    static readonly DebitPatientPay: string = '00000078-1000-0000-0000-000000000012';
    static readonly CreditPaymentFromPatientCredit: string = '00000078-1000-0000-0000-000000000013';
    static readonly CreditCreatedFromPaymentVoid: string = '00000078-1000-0000-0000-000000000014';
    static readonly WriteOff: string = '00000078-1000-0000-0000-000000000015';
}
